import {FileTableConfiguration} from './FileTableConfiguration';

export class FileToTableConfiguration extends FileTableConfiguration {
detailLog: boolean | null;
exitStatusOnNoData: boolean | null;
exitStatusOnNoReadFile: boolean | null;
exitStatusOnReadFile: boolean | null;
historyFile: boolean | null;
keepFile: boolean | null;
readFileFromBucket: boolean | null;
truncateIfExists: boolean | null;
useMerge: boolean | null;
}

